function LoadingCard({ count = 1, height = 'h-12' }: { count?: number; height?: string }) {
    const li = Array.from(Array(count)).map(function (x, i) {
        return i;
    });
    return (
        <div className='animate-pulse'>
            {li.map(i => {
                return <div key={i} className={`mb-1  w-full rounded-md bg-gray-100 ${height}`}></div>;
            })}
        </div>
    );
}

export default LoadingCard;
